export { DynamicModalComponent } from './dynamic-modal/dynamic-modal.component';
export { DynamicModalService } from './dynamic-modal/dynamic-modal.service';
